import Vue from "vue"
import Vuex from "vuex"


Vue.use(Vuex);
const store = new Vuex.Store({
	modules: {
	},
	state: {
		colors: ["#000", "#2ecc71", "#e67e22", "#2980b9", "#d35400", "#1abc9c", "#2c3e50", "#2980b9", "#8e44ad", "#5ebbeb"],
		phone: /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/,
		name: /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/,
		id: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
		path: false
	},
	mutations: {
		setPath(state, val) {
			state.path = val
		}
	},
	actions: {

	},
	getters: {
		setTime(val, date = "-", time = ":") {
			var d = new Date(val)
			let str = "";
			str += d.getFullYear() + date;
			str += (d.getMonth() < 9 ? "0" + d.getMonth() : d.getMonth()) + date;
			str += d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
			str += " " + (d.getHours() < 9 ? "0" + d.getHours() : d.getHours()) + " " + time + " ";
			str += (d.getMinutes() < 9 ? "0" + d.getMinutes() : d.getMinutes());
			return str;
		}
	}
})

export default store;
